import { useContext } from "react";
import { store } from "Models/Store";
import { MotorVehicleDispatchContext, MotorVehicleSearchContext } from "./MotorVehicleSearchReducers";
import { BusinessPaymentSelector } from "../BusinessPaymentSelector/BusinessPaymentSelector";

export const MotorVehicleBillingEntityDetail: React.FunctionComponent = () => {
	const { data: generateMotorVehicleSearchDetail } = useContext(MotorVehicleSearchContext);
	const dispatch = useContext(MotorVehicleDispatchContext);

	const chargeType = store.getUser?.organisation?.accountType === 'INVOICED'
		? (store.getUser?.organisation?.enforceOnlinePayments ? 'PAYG' : 'INVOICED')
		: 'PAYG'

	// So super user doesnt see everything
	const filterBusinessByOrgId = store?.getUser?.organisation?.id;

	return (
		<>
			<BusinessPaymentSelector
				filterByOrgId={filterBusinessByOrgId}
				type={chargeType}
				value={generateMotorVehicleSearchDetail.businessPaymentMethod?.businessId}
				setValue={newValue => {
					dispatch({ type: "SetBusinessPaymentMethod", payload: { businessPaymentMethod: newValue } });
				}}
			/>
		</>
	);
}